import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { clearToken } from "../slices/authSlice";
import { BASE_URL } from "../../config/url";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    // Access auth state directly from getState
    const state = getState() as any;
    const token = state?.auth?.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  // Log request details
  console.log("🚀 API Request:", {
    url: `${BASE_URL}${args.url}`,
    method: args.method || "GET",
    body: args.body,
    headers: args.headers,
    baseUrl: BASE_URL,
  });

  let result = await baseQuery(args, api, extraOptions);

  // Log response details
  console.log("📥 API Response:", {
    url: `${BASE_URL}${args.url}`,
    status: result.error ? (result.error as any).status : "success",
    originalStatus: result.error && "originalStatus" in result.error ? (result.error as any).originalStatus : undefined,
    data: result.data,
    error: result.error,
  });

  // Handle 404 errors and PARSING_ERROR (when server returns HTML instead of JSON)
  if (result.error) {
    const error = result.error as any;
    const status = error.status;
    const originalStatus = error.originalStatus;

    // Handle 401 Unauthorized (Session Expired)
    if (
      status === 401 ||
      (error.data && error.data.statusCode === 401) ||
      (error.data && error.data.isSessionExpired === true)
    ) {
      console.log("❌ 401 Unauthorized - Clearing token");
      api.dispatch(clearToken());
    }

    // Handle 404 or PARSING_ERROR with 404 originalStatus
    if (status === 404 || (status === "PARSING_ERROR" && originalStatus === 404)) {
      console.log("❌ 404 Error - Clearing token");
      // Clear token from auth slice
      api.dispatch(clearToken());
    }

    // Handle PARSING_ERROR (server returned HTML instead of JSON)
    if (status === "PARSING_ERROR") {
      console.error("❌ PARSING_ERROR: Server returned HTML instead of JSON. This usually means:");
      console.error("   1. The endpoint doesn't exist (404)");
      console.error("   2. The base URL is incorrect");
      console.error("   3. The server is returning an error page");
      console.error(`   Full URL attempted: ${BASE_URL}${args.url}`);
    }
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "AUTH",
    "USER",
    "Customer",
    "Admin",
    "Flavour",
    "BoxArt",
    "Topping",
    "GreekBox",
    "Yogurt",
    "YogurtType",
    "Product",
    "Category",
    "Store",
    "CMS",
    "Dispatcher",
    "Common",
    "ORDER",
    "LOYALTY",
    "RATING",
    "SubAdmin",
    "PROFILE",
    "FAQ",
  ],
  endpoints: () => ({}),
});
